import React, { useRef, useState } from 'react';
import { Gamepad2 } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';
import { useSimBridge } from '../../hooks/useSimBridge';
import { SimStage } from './SimStage';
import { QuestionsCard } from './QuestionsCard';
import { SimTabs } from './SimTabs';

const pick = (lang, ar, en) => (lang === 'en' && en ? en : ar);

// Shared by the public page and the admin preview.
export const SimulationViewer = ({ sim }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const frameRef = useRef(null);
  const [runKey, setRunKey] = useState(0);
  const bridge = useSimBridge(frameRef, runKey, sim.actions || []);
  const hasQs = (sim.questions || []).length > 0;
  return (
    <div data-testid="sim-viewer">
      <div className="mb-5">
        <h1 className="flex flex-wrap items-center gap-3 text-2xl sm:text-3xl font-black text-slate-900">
          <Gamepad2 className="w-8 h-8 text-blue-600" />
          <span data-testid="sim-title">{pick(lang, sim.titleAr, sim.titleEn)}</span>
          <span className="px-3 py-1 rounded-lg bg-blue-100 text-blue-700 text-sm font-bold">{L('محاكاة تفاعلية', 'Interactive simulation')}</span>
        </h1>
        {sim.descAr && <p className="text-slate-500 text-sm sm:text-base mt-2">{pick(lang, sim.descAr, sim.descEn)}</p>}
      </div>
      <div className="flex flex-col gap-5 lg:grid lg:grid-cols-[380px_minmax(0,1fr)] lg:items-start">
        <div className="contents lg:flex lg:flex-col lg:gap-5 lg:col-start-2 lg:row-start-1 min-w-0">
          <div className="order-1 min-w-0"><SimStage sim={sim} frameRef={frameRef} bridge={bridge} runKey={runKey} onReload={() => setRunKey(k => k + 1)} /></div>
          <div className="order-4 min-w-0"><SimTabs sim={sim} /></div>
        </div>
        <aside className="contents lg:flex lg:flex-col lg:gap-5 lg:col-start-1 lg:row-start-1 min-w-0">
          <div className="order-2 min-w-0">{hasQs && <QuestionsCard questions={sim.questions} bridge={bridge} />}</div>
        </aside>
      </div>
    </div>
  );
};
